import { Api } from '../../../../api';
import Topbar from '../../../PulseSurvey/Topbar';
import React, { useEffect, useState } from 'react';
import Icons from '../../../../component/svgs/icons';
import { surveyApi } from '../../../../api/surveyApi';
import { CompanyApi } from '../../../../api/companyApi';
import Loader from '../../../../component/common/Loader';
import { useLocation, useNavigate } from 'react-router-dom';
import { errorToast, getPathForSurvey, successToast } from '../../../../utils/helper';
import CommonSelect from '../../../../component/common/select/CommonSelect';
import AddEditChallangesValidation from '../../../../validation/AddEditChallangesValidation';
import ChallangeSuccessModal from '../../../../component/common/modals/ChallangeSuccessModal';
import ChallangeApprovalModal from '../../../../component/common/modals/ChallangeApprovalModal';

const points = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 30, label: '30' },
  { value: 40, label: '40' },
  { value: 50, label: '50' },
  { value: 60, label: '60' },
  { value: 70, label: '70' },
  { value: 80, label: '80' },
  { value: 90, label: '90' },
  { value: 100, label: '100' },
  { value: 200, label: '200' },
  { value: 500, label: '500' }
];

const contents = [
  { value: 0, label: 'Invite Friend' },
  { value: 1, label: 'Affirmation' },
  { value: 2, label: 'Meditation' },
  { value: 3, label: 'Sound' },
  { value: 4, label: 'Shoorah Pods' },
  { value: 5, label: 'Gratitude' },
  { value: 6, label: 'Rituals' },
  { value: 7, label: 'Survey' },
  { value: 8, label: 'Breathwork' },
  { value: 9, label: 'Self Assessment' },
  { value: 10, label: 'Tutorial' },
  { value: 11, label: 'Peap' },
  { value: 12, label: 'Cleanse' },
  { value: 13, label: 'Goal' }
];

const steps = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' }
];

const devices = [
  { value: 'Sleep challenge', label: 'Sleep challenge' },
  { value: 'Water Intake', label: 'Water Intake' },
  { value: 'Daily macros', label: 'Daily macros' }
];

const AddEditChallanges = () => {
  const navigate = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [rewards, setRewards] = useState([]);
  const [connect, setConnect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [adminList, setSuperAdminList] = useState([]);
  const { userType } = JSON.parse(localStorage.getItem('userData'));
  const location = new URLSearchParams(window.location.search);
  const id = location.get('id');
  const view = location.get('view');
  const week = location.get('week');
  const [error, setError] = useState({
    title: '',
    description: '',
    points: '',
    sync: '',
    content_type: '',
    rewardId: '',
    approvalBy: ''
  });
  const [challenge, setChallenge] = useState({
    challengeId: '',
    title: '',
    description: '',
    points: '',
    content_type: '',
    step_count: '',
    rewardId: '',
    sync: '',
    approvalBy: ''
  });

  const handleChange = (e) => {
    setChallenge({ ...challenge, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: '' });
  };

  const handleChange2 = (e, name) => {
    setChallenge({ ...challenge, [name]: e.value });
    setError({ ...error, [name]: '' });
  };

  const handleClose = () => {
    setOpen(false);
    navigate(getPathForSurvey(`/team-challanges/add-edit-weekly-challenges?week=${week}`));
  };

  const getadminList = () => {
    surveyApi.getAdminList(0).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        setOpen2(true);
        setLoading(false);
        setSuperAdminList(response?.data?.data);
      } else {
        setLoading(false);
      }
    });
  };

  const getadminList2 = () => {
    CompanyApi.getAdminListCompany(3).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        setOpen2(true);
        setLoading(false);
        setSuperAdminList(response?.data?.data);
      } else {
        setLoading(false);
      }
    });
  };

  const handleSubmit = () => {
    const { errors, isValid } = AddEditChallangesValidation(challenge);
    setError(errors);
    if (isValid && week) {
      const payload = {
        title: challenge.title,
        description: challenge.description,
        points: challenge.points,
        content_type: challenge.content_type,
        step_count: challenge.step_count,
        week: week
      };
      connect && (payload.sync = challenge.sync);
      connect && (payload.connect = connect);
      if (id) {
        payload.challengeId = challenge.challengeId;
        if (userType === 0 || userType === 1) {
          if (userType === 0) {
            payload.status = 1;
            setLoading(true);
            Api.addChallange(payload)
              .then((response) => {
                if (response?.data?.meta?.code === 200) {
                  setOpen(true);
                  setLoading(false);
                  successToast(response?.data?.meta?.message);
                } else {
                  setLoading(false);
                }
              })
              .catch((error) => {
                setLoading(false);
              });
          } else {
            payload.status = 0;
            setLoading(true);
            Api.addChallange(payload).then((response) => {
              if (response?.data?.meta?.code === 200) {
                setOpen(false);
                getadminList();
                successToast(response?.data?.meta?.message);
                localStorage.setItem('challengeId', String(response?.data?.data?._id));
              } else {
                setLoading(false);
              }
            });
          }
        } else {
          if (userType === 3 || userType === 4) {
            if (userType === 3) {
              setOpen(true);
              console.log('++++++++++++++++ , handleSubmit , payload', payload);
            } else {
              setLoading(true);
              getadminList2();
            }
          }
        }
      } else {
        if (userType === 0 || userType === 1) {
          if (userType === 0) {
            payload.status = 1;
            setLoading(true);
            Api.addChallange(payload)
              .then((response) => {
                if (response?.data?.meta?.code === 200) {
                  setOpen(true);
                  setLoading(false);
                  successToast(response?.data?.meta?.message);
                } else {
                  setLoading(false);
                }
              })
              .catch((error) => {
                setLoading(false);
              });
          } else {
            payload.status = 0;
            setLoading(true);
            Api.addChallange(payload).then((response) => {
              if (response?.data?.meta?.code === 200) {
                setOpen(false);
                getadminList();
                successToast(response?.data?.meta?.message);
                localStorage.setItem('challengeId', String(response?.data?.data?._id));
              } else {
                setLoading(false);
              }
            });
          }
        } else {
          if (userType === 3 || userType === 4) {
            if (userType === 3) {
              setOpen(true);
              console.log('++++++++++++++++ , handleSubmit , payload', payload);
            } else {
              setLoading(true);
              getadminList2();
            }
          }
        }
      }
    } else {
      errorToast('Please select week.');
    }
  };

  const handleSendChallengeWithApproval = () => {
    const challengeId = localStorage.getItem('challengeId');
    if (challenge?.approvalBy && challengeId) {
      const payload = {
        status: 2,
        challengeId: challengeId,
        approvalBy: challenge.approvalBy
      };
      connect && (payload.sync = challenge.sync);
      connect && (payload.connect = connect);
      challenge.challengeId && (payload.challengeId = challenge.challengeId);
      setLoading(true);
      Api.addChallange(payload)
        .then((response) => {
          if (response?.data?.meta?.code === 200) {
            setOpen(true);
            setOpen2(false);
            setLoading(false);
            localStorage.removeItem('challengeId');
            successToast(response?.data?.meta?.message);
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      setError({ ...error, approvalBy: 'Please select admin.' });
    }
  };

  const fetchChallage = () => {
    setLoading(true);
    const query = `page=1&id=${id}`;
    Api.getChallanges(query)
      .then((response) => {
        if (response?.data?.meta?.code === 200) {
          const res = response?.data?.data?.[0];
          setChallenge({
            challengeId: res?._id,
            title: res?.title,
            description: res?.description,
            points: res?.points,
            content_type: res?.content_type,
            step_count: res?.step_count,
            sync: res?.sync
          });
          setConnect(res?.connect);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchRewards = async () => {
    setLoading(true);
    const query = `page=1&status=1&limit=6`;
    const res = await Api.getRewards(query);
    if (res?.data?.meta?.code === 200) {
      setRewards(res?.data?.data);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchChallage();
      // fetchRewards();
    }
  }, [id]);

  return (
    <div className="mx-auto max-w-[1640px] hide-scrollbar font-work-sans">
      {loading && <Loader />}
      <div className="font-work-sans lg:ps-5">
        <Topbar title={id ? 'Edit Challenge' : 'New Challenge'} />

        <div className="lg:mt-10 rounded-2xl border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-none sm:p-6 p-4">
          <div className="sm:grid sm:grid-cols-12 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg gap-5 sm:w-[80%] add-survey-card">
            <div className="col-span-7">
              <label htmlFor="title" className="font-medium text-[16px] leading-9 mb-1">
                Challenge Title
              </label>
              <div className="input-field">
                <input
                  className="w-full h-10 bg-shoorah-normanGray border-[1.5px] text-[14px] border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none"
                  type="text"
                  name="title"
                  id="title"
                  autoComplete="off"
                  disabled={view === 'preview_only'}
                  value={challenge.title}
                  onChange={handleChange}
                  placeholder="Enter title"
                />
              </div>
              {error.title && <span className="text-red-500 text-sm">{error.title}</span>}
            </div>
            <div className="col-span-5">
              <label htmlFor="points" className="font-medium text-[16px] leading-9 mb-1">
                Challenges Points
              </label>
              <div className="input-field">
                <CommonSelect
                  name="points"
                  options={points}
                  disabled={view === 'preview_only'}
                  onChange={(e) => handleChange2(e, 'points')}
                  value={points.find((option) => option.value === challenge.points)}
                />
              </div>
              {error.points && <span className="text-red-500 text-sm">{error.points}</span>}
            </div>
            <div className="col-span-4">
              <label htmlFor="content_type" className="font-medium text-[16px] leading-9 mb-1">
                Challenges Type
              </label>
              <div className="input-field">
                <CommonSelect
                  name="content_type"
                  options={contents}
                  disabled={view === 'preview_only'}
                  onChange={(e) => handleChange2(e, 'content_type')}
                  value={contents.find((option) => option.value === challenge.content_type)}
                />
              </div>
              {error.content_type && (
                <span className="text-red-500 text-sm">{error.content_type}</span>
              )}
            </div>
            <div className="col-span-4">
              <label htmlFor="step_count" className="font-medium text-[16px] leading-9 mb-1">
                Step Count
              </label>
              <div className="input-field">
                <CommonSelect
                  name="step_count"
                  options={steps}
                  disabled={view === 'preview_only'}
                  onChange={(e) => handleChange2(e, 'step_count')}
                  value={steps.find((option) => option.value === challenge.step_count)}
                />
              </div>
              {error.step_count && <span className="text-red-500 text-sm">{error.step_count}</span>}
            </div>
            <div className="col-span-4">
              <label htmlFor="rewardId" className="font-medium text-[16px] leading-9 mb-1">
                Rewards
              </label>
              <div className="input-field">
                <CommonSelect
                  name="rewardId"
                  options={rewards}
                  disabled={view === 'preview_only'}
                  onChange={(e) => handleChange2(e, 'rewardId')}
                  value={rewards.find((option) => option.value === challenge.rewardId)}
                />
              </div>
              {error.rewardId && <span className="text-red-500 text-sm">{error.rewardId}</span>}
            </div>
          </div>
          <div className="text-[16px] text-shoorah-lightBlack lg:mt-6 mt-5 sm:w-[80%] dark:text-shoorah-darkBg">
            <label htmlFor="description" className="font-medium text-[16px] leading-9 mb-1">
              Challenge Description
            </label>
            <div className="input-field">
              <textarea
                className="w-full block rounded-lg px-4 py-2 text-[14px] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray sm:min-h-[100px] min-h-[110px] resize-none mb-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none"
                name="description"
                id="description"
                autoComplete="off"
                disabled={view === 'preview_only'}
                value={challenge.description}
                onChange={handleChange}
                placeholder="Enter description"
              ></textarea>
            </div>
            {error.description && <span className="text-red-500 text-sm">{error.description}</span>}
          </div>
        </div>

        <div className="mt-5 rounded-2xl border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-none sm:p-6 p-4">
          <div className="flex items-center sm:px-3 px-2 py-[7px] border-[1.5px] border-shoorah-borderGray rounded-[25px] dark:border-shoorah-darkBg w-[215px]">
            <input
              id="other-ans-choice-1"
              type="checkbox"
              checked={connect}
              disabled={view === 'preview_only'}
              className="rounded-answer-choice"
              onChange={() => setConnect(!connect)}
            />
            <label
              htmlFor="other-ans-choice-1"
              className="ml-3 text-[12px] font-medium leading-6 text-shoorah-lightBlack dark:text-shoorah-darkBg"
            >
              Connect to wearable device
            </label>
          </div>
          {connect && (
            <div className="text-[16px] text-shoorah-lightBlack mt-6 sm:w-[20%] dark:text-shoorah-darkBg">
              <label htmlFor="sync" className="font-medium text-[16px] leading-9 mb-1">
                Sync to challenge
              </label>
              <div className="input-field">
                <CommonSelect
                  name="sync"
                  options={devices}
                  disabled={view === 'preview_only'}
                  onChange={(e) => handleChange2(e, 'sync')}
                  value={devices.find((option) => option.value === challenge.sync)}
                />
              </div>
            </div>
          )}
        </div>

        {view !== 'preview_only' && (
          <div className="lg:mt-8 mt-5 flex justify-end">
            <button
              onClick={handleSubmit}
              className="bg-shoorah-secondary text-white px-5 py-2 rounded-full text-[16px] font-medium leading-6 flex items-center gap-2"
            >
              Publish Challenge <Icons.chevronRightIcon />
            </button>
          </div>
        )}
      </div>
      <ChallangeSuccessModal
        open={open}
        btn="Manage Challenge"
        message="You’ve successfully created a challenge"
        desc="You can now manage this challenge and access valuable insights"
        handleClose={handleClose}
      />
      <ChallangeApprovalModal
        open={open2}
        btn="My Challenges"
        message="You're currently unable to share this challenge"
        desc="Send the challenge to an admin to gain approval"
        adminList={adminList}
        error={error.approvalBy}
        handleChange={(e) => {
          setChallenge({ ...challenge, approvalBy: e.value });
          setError({ ...error, approvalBy: '' });
        }}
        handleSendChallengeWithApproval={() => handleSendChallengeWithApproval()}
      />
    </div>
  );
};

export default AddEditChallanges;
